module.exports = __webpack_public_path__ + "static/media/mars2.674de013.png";